export default __webpack_public_path__ + "static/media/info-error.ad06ea2e.svg";